import { Component, EventEmitter, Input, Output } from '@angular/core';

// Previous and next around "from–to of total"; hidden while everything fits on one page
@Component({
  selector   : 'wor-pager',
  template: require('./pager.component.html')
})
export class PagerComponent {
  @Input() isDisabled : boolean = false;
  @Input() page       : number  = 1;
  @Input() pageSize   : number  = 25;
  @Input() total      : number  = 0;

  @Output() pageChange : EventEmitter<number> = new EventEmitter<number>();

  get from () : number {
    return this.total
      ? ( this.page - 1 ) * this.pageSize + 1
      : 0;
  }

  get hasNext () : boolean {
    return this.page * this.pageSize < this.total;
  }

  get hasPrevious () : boolean {
    return this.page > 1;
  }

  get isVisible () : boolean {
    return this.total > this.pageSize || this.page > 1;
  }

  get to () : number {
    return Math.min(this.page * this.pageSize, this.total);
  }

  next () : void {
    if ( this.hasNext ) {
      this.pageChange.emit(this.page + 1);
    }
  }

  previous () : void {
    if ( this.hasPrevious ) {
      this.pageChange.emit(this.page - 1);
    }
  }
}
